up.compiler('.js-publication_brand_color', element => {
  document.documentElement.style.setProperty('--publication-brand-color', element.dataset.publicationBrandColor)
  document.documentElement.style.setProperty(
    '--publication-brand-color-alpha-03',
    element.dataset['publicationBrandColorAlpha-03']
  )
  document.documentElement.style.setProperty(
    '--publication-brand-color-darker',
    element.dataset.publicationBrandColorDarker
  )
  document.documentElement.style.setProperty(
    '--publication-brand-color-darker-alpha-03',
    element.dataset['publicationBrandColorDarkerAlpha-03']
  )
  document.documentElement.style.setProperty(
    '--publication-brand-text-color',
    element.dataset.publicationBrandTextColor
  )
})
